// dependencies
import { List, Map, Set, fromJS } from "immutable";

const initialState = Map({
	goalMap: Map(),
	goalPickerResults: Map(),
	recentGoalPickerSearches: Set(),
	goalQueryList: List(),
	mostRecentRequestID: Map(),
});

export default function fields(state = initialState, action) {
	switch (action.type) {
		/**
		 * The response from the goal picker. This will only keep the most
		 * recent 10 results.
		 */
		case "GOALS:SEARCH@SUCCESS": {
			const cacheResultsCount = 10;
			const { goals, searchID } = action.response;

			// create result value
			const value = Map({
				goals,
				requestData: action.request.data,
			});

			let goalPickerResults = state.get("goalPickerResults");
			let recentGoalPickerSearches = state.get("recentGoalPickerSearches");

			// update our list of recent searches, take the last 10
			recentGoalPickerSearches = recentGoalPickerSearches.add(searchID).takeLast(cacheResultsCount);

			// update our results map, removing anything thats not in our
			// recent searches
			goalPickerResults = goalPickerResults.withMutations((mutable) => {
				mutable.filter((id) => recentGoalPickerSearches.includes(id));
			});

			// update the state
			return state.withMutations((mutable) => {
				mutable.set("recentGoalPickerSearches", recentGoalPickerSearches);
				mutable.set("goalPickerResults", goalPickerResults.set(searchID, value));
			});
		}

		case "GOALS:GETSINGLE@SUCCESS": {
			const currentGoalMap = state.get("goalMap");
			const mergedGoalMap = currentGoalMap.merge(action.response);

			return state.setIn(["goalMap"], mergedGoalMap);
		}

		case "GOALS:FETCH@START": {
			return state.setIn(["mostRecentRequestID", "goals"], action.config.payload.requestID);
		}

		case "GOALS:FETCH@SUCCESS": {
			const currentGoalMap = state.get("goalMap");
			const goalResponse = action.response.toJS().goals;
			const { requestID } = action.request.props.payload;

			const mostRecentRequestID = state.getIn(["mostRecentRequestID", "goals"]);

			if (requestID !== mostRecentRequestID) {
				return state;
			}

			const goalsObject = goalResponse.reduce((acc, goal) => {
				const accumulator = acc;
				accumulator[goal.id] = goal;
				return accumulator;
			}, {});

			const goalsList = goalResponse.map(({ id }) => id);

			const mergedGoalMap = currentGoalMap.merge(fromJS(goalsObject));

			// const mergedGoalMap = currentGoalMap.merge(goalMap);
			// console.log(mergedGoalMap);
			return state.withMutations((mutable) => {
				mutable.set("goalMap", mergedGoalMap);
				mutable.set("goalQueryList", List(goalsList));
			});
		}
		default:
			return state;
	}
}
